import { I18n } from "@assets/strings";
import moment from "moment";
import React from "react";
import styled from "styled-components";
import { useCurrentProfile } from "@domain/currentProfile/hooks";
import { Group } from "@domain/group/group";
import { capitalizeWord } from "@utils/strings";
import { PrimaryButton } from "@ui/components/buttons/primaryButton";
import { Clamp } from "@ui/components/containers/clamp";
import { Description } from "@ui/components/containers/description";
import { ClosableModal } from "@ui/modals/closableModal";
import { useModalTools } from "@ui/modals/modalContext";
import { mobile } from "@ui/styles/utils";
import { ModalPaiement } from "./modalPaiement";

interface OmatModalInoProps extends React.HTMLAttributes<HTMLDivElement> {
	close: () => void;
	shareroom: Group;
}

export const SubscriptionSummary: React.FC<OmatModalInoProps> = ({ close, shareroom, ...htmlProps }) => {
	const currentProfile = useCurrentProfile();
	const currentLanguage = currentProfile?.language === "ENGLISH" ? "en" : "fr";
	moment.locale(currentLanguage);
	const { createModal } = useModalTools();
	const showModalTypePaiement = (): void => {
		close();
		createModal((close) => <ModalPaiement shareroom={shareroom} close={close} />);
	};
	return (
		<Container close={close} title={I18n.t("shareroom.subscription.summary.title")} isStartSubscriber {...htmlProps}>
			<DescriptionContent>{I18n.t("shareroom.subscription.summary.description")}</DescriptionContent>
			<SubscriberDetails>{I18n.t("shareroom.subscription.detail.title")}</SubscriberDetails>
			<ItemsBloc>
				<Item>
					<Label>{capitalizeWord(I18n.t("shareroom.subscription.classroom.title"))}</Label>
					<Value>
						<b>{shareroom.name}</b>
					</Value>
				</Item>
				<Item>
					<Label>{capitalizeWord(I18n.t("shareroom.subscription.mode.title"))}</Label>
					<Value>
						<b>{I18n.t(`shareroom.dashboard.pricing.form.subscription_mode.${shareroom.pricing.subscriptionMode}`)}</b>
					</Value>
				</Item>
				<Item>
					<Label>{capitalizeWord(I18n.t("shareroom.subscription.startdate.title"))}</Label>
					<Value>
						{/* <b>{moment(new Date()).format(" Do MMMM YYYY")}</b> */}
						<b>{moment(new Date()).format("ll")}</b>
					</Value>
				</Item>
				<Item>
					<Label>{capitalizeWord(I18n.t("shareroom.subscription.enddate.title"))}</Label>
					<Value>
						<b>{moment().add(1, "months").format("ll")}</b>
					</Value>
				</Item>
				<Item>
					<Label>{capitalizeWord(I18n.t("shareroom.dashboard.pricing.form.subscription_price"))}</Label>
					<Value>
						<b>
							{shareroom.pricing.priceInUserCurrency} {currentProfile?.currency}
						</b>
					</Value>
				</Item>
			</ItemsBloc>
			<BlocButton>
				<StyledButtonContainer onClick={showModalTypePaiement}>{I18n.t("validate")}</StyledButtonContainer>
			</BlocButton>
		</Container>
	);
};

const Container = styled(ClosableModal)`
	position: relative;
`;
const SubscriberDetails = styled.div`
	${({ theme }) => theme.textStyles.subdescription}
	color: "black";
	font-size: 1.01rem;
	margin-top: 40px;
`;
const ItemsBloc = styled.div``;
const Item = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	margin-top: 20px;
`;
const Label = styled(Clamp)`
	${({ theme }) => theme.textStyles.secondary}
	color: rgba(0, 0, 0, 0.5);
	font-size: 14px;
	@media ${mobile} {
		font-size: 12px;
	}
`;
const Value = styled(Clamp)`
	color: "black";
	font-size: 15px;
	@media ${mobile} {
		font-size: 11px;
	}
`;
const DescriptionContent = styled(Description)`
	margin-top: 25px;
	text-align: justify;
`;
const BlocButton = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	margin-top: 40px;
`;
const StyledButtonContainer = styled(PrimaryButton)``;
